import { useTranslation } from 'react-i18next'
import { CurecallButton, PlusIcon, ECurecallSize } from '@honestica/curecall-ui'

type TAddingNodeButtonProps = {
  onClick: (e: React.MouseEvent) => void
}

export function AddingNodeButton({ onClick }: TAddingNodeButtonProps) {
  const { t } = useTranslation()

  return (
    <CurecallButton
      ariaLabelText={t('pages.configuration.followups.chatbot.node-editor.add-node')}
      iconType={<PlusIcon />}
      onClick={onClick}
      size={ECurecallSize.SMALL}
      className="c-text-primary c-w-4 c-h-4 c-p-0 [&>div]:c-w-4 [&>div]:c-h-4"
    />
  )
}
